import { ProductPrice } from '@/domain/ProductPrice'
import { CustomerInfo } from '@/domain/CustomerInfo'
import { CustomerPrimaryKey } from '@/domain/Customer'
import axios from 'axios'

/**
 * 顧客価格サービス
 */
export default class CustomerPricesService {
    /** インスタンス */
    private static _instance: CustomerPricesService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new CustomerPricesService();
        }
        return this._instance;
    }

    /**
     * 更新
     */
    public async update(prefectureCode: string, code: string, list: ProductPrice[]) {
        return await axios.put(`/api/customer_price/edit/${prefectureCode}/${code}`, list)
            .then((results) => {
                if (results.status === 200) {
                    return
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }

    /**
     * 複写
     */
    public async copy(srcCustomerInfo: CustomerInfo, dstCustomers: CustomerInfo[]) {
        const list = dstCustomers.map(x => 
            new CustomerPrimaryKey({prefectureCode: x.customerPrefectureCode, code: x.customerCode, branchNumber: x.customerBranchNumber})
        )
        return await axios.put(`/api/customer_price/copy/${srcCustomerInfo.customerPrefectureCode}/${srcCustomerInfo.customerCode}`, list)
            .then((results) => {
                if (results.status === 200) {
                    return
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
}
